import styled, { keyframes } from 'styled-components';
import { COLOR_BLACK, COLOR_ORANGE } from '../../assets/styles/colors';
import { rgba } from 'polished';
import { BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

const pulseAnim = keyframes`
  0% {
    transform: scale(1, 1);
  }
  50% {
    opacity: 0.3;
  }
  100% {
    transform: scale(1.1, 1.6);
    opacity: 0;
  }
`;

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  .required-documents-wrapper {
    width: 100%;
    max-width: 803px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 32px;

    .two-columns {
      display: flex;
      justify-content: space-around;
      width: 100%;
      padding-top: 45px;

      .column {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 25px;

        p {
          margin: 0;
        }
      }
    }

    .subtext {
      color: #f7931e;
    }

    @media (max-width: ${BP_MOBILE_MAX}px) {
      .subtext {
        text-align: center;
      }
    }
  }

  .divider {
    height: 1px;
    width: 100%;
    max-width: 803px;
    margin-bottom: 24px;
    display: flex;
    background: ${rgba(COLOR_BLACK, 0.2)};
  }

  .loading-wrap,
  .err-wrap {
    min-height: calc(100vh - 350px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
    .mid-info-text {
      padding: 10px 0 25px 0;
    }
  }

  .final-button-wrap {
    display: flex;
    width: 100%;
    justify-content: center;

    .pulse-container {
      position: relative;

      .pulse {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 8px;
        animation: ${pulseAnim} 1s ease infinite;
        background: ${rgba(COLOR_ORANGE, 0.5)};
      }
    }

    .pulsing {
      animation: pulseAnim 3s ease-in-out infinite alternate;
      box-shadow: 0 0 50px 10px rgba(250, 181, 53, 1);
      opacity: 1;
    }

    @keyframes pulseAnim {
      50% {
        box-shadow: 0 0 50px 10px rgba(250, 181, 53, 0.5);
        opacity: 0.5;
      }
    }
  }
`;

export const ContentWrapSC = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
